import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getUsers: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    let userDetails = store.getState("auth");
    let store_id = userDetails.user.store_id;
    const users = await api.get(`stores/${store_id}/users`);
    users.reduce(
      (acl: { [key: string]: any }, curr: { [key: string]: any }) => {
        acl[curr.id] = curr;
        return acl;
      },
      {}
    );

    await store.update((state) => {
      state.users = users;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const getPosUsers: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    const posUser = await api.get(`pos-users/`);
    console.log("posUserList", posUser);
    posUser.reduce(
      (acl: { [key: string]: any }, curr: { [key: string]: any }) => {
        acl[curr.id] = curr;
        return acl;
      },
      {}
    );
    await store.update((state) => {
      state.posUsers = posUser;
    });
  } catch (error) {
    console.log("error", error);
  }
};
const updateUser: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object
) => {
  try {
    let userDetails = store.getState("auth", "user");
    let storeId = userDetails.store_id;
    await api.patch(`stores/${storeId}/users/${id}`, {}, values);
    // await store.update(state => {
    //   if (state.users !== undefined) {
    //     state.users[updateUser.id] = updateUser;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const updatePOSUser: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object
) => {
  try {
    // let userDetails = store.getState("auth","user");
    // let storeId = userDetails.store_id;
    await api.patch(`pos-users/${id}`, {}, values);

    // await store.update(state => {
    //   if (state.posUsers !== undefined) {
    //     state.posUsers[updatePOSUser.id] = updatePOSUser;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const resetUserPassword: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object
) => {
  try {
    let userDetails = store.getState("auth", "user");
    let storeId = userDetails.store_id;
    const resetPassword = await api.patch(
      `stores/${storeId}/users/${id}/reset-password`,
      {},
      values
    );
    await store.update((state) => {
      if (state.users !== undefined) {
        state.users[resetPassword.id] = resetPassword;
      }
    });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const resetPOSUserPassword: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object
) => {
  try {
    // let userDetails = store.getState("auth","user");
    // let storeId = userDetails.store_id;
    const resetPOSUserPassword = await api.patch(
      `pos-users/reset-password/${id}`,
      {},
      values
    );

    await store.update((state) => {
      if (state.users !== undefined) {
        state.users[resetPOSUserPassword.id] = resetPOSUserPassword;
      }
    });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const updateLoggedUserStatus: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object,
  status: string
) => {
  try {
    let userDetails = store.getState("auth", "user");
    let storeId = userDetails.store_id;
    await api.patch(`stores/${storeId}/pos-users/${id}/${status}`, {}, values);

    // await store.update(state => {
    //   if (state.loggedPosUsers !== undefined) {
    //     state.loggedPosUsers[updateUser.id] = updateUser;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    //throw error
  }
};
const createUser: EvokeAction<AppState, AppActions> = async (
  store,
  values: object
) => {
  try {
    let userDetails = store.getState("auth");
    let storeId = userDetails.user.store_id;
    const createdUser = await api.post(`stores/${storeId}/users/`, {}, values);
    if (!createdUser.error) {
      await store.update((state) => {
        if (state.users !== undefined) {
          state.users[createdUser.id] = createdUser;
        }
      });
    }
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const getLoggedPosUsers: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    // let userDetails = store.getState("auth");
    // let store_id = userDetails.user.store_id;
    const posUser = await api.get(`pos-users/logged-in`);

    posUser.reduce(
      (acl: { [key: string]: any }, curr: { [key: string]: any }) => {
        acl[curr.id] = curr;
        return acl;
      },
      {}
    );
    await store.update((state) => {
      state.loggedPosUsers = posUser;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const userActions = {
  getUsers,
  createUser,
  updateUser,
  resetUserPassword,
  resetPOSUserPassword,
  getPosUsers,
  getLoggedPosUsers,
  updateLoggedUserStatus,
  updatePOSUser,
};
